const variantIdInput = document.querySelector('.product-variant-id');
const mainGallery = document.querySelector('[data-gallery-swiper]').swiper;
const thumbGallery = document.querySelector('[data-thumbs-swiper]').swiper;
const priceDisplay = document.querySelector('.price__container');

// Store all original slides for later restoration
let allOriginalSlides = [];
let allOriginalThumbs = [];

function switchGallery(variantId) {
    // Store original slides on first run if not already stored
    if (allOriginalSlides.length === 0) {
        const allSlides = document.querySelectorAll('.main-product-gallery__slide');
        const allThumbs = document.querySelectorAll('.main-product-gallery__thumbnail');
        
        allOriginalSlides = Array.from(allSlides);
        allOriginalThumbs = Array.from(allThumbs);
    }

    // Get slides and thumbs for this variant (and for data-variant="0")
    const variantSlides = allOriginalSlides.filter(slide => 
        slide.getAttribute('data-variant') === variantId || 
        slide.getAttribute('data-variant') === '0'
    );
    const variantThumbs = allOriginalThumbs.filter(thumb => 
        thumb.getAttribute('data-variant') === variantId || 
        thumb.getAttribute('data-variant') === '0'
    );

    // Remove all slides from both galleries
    mainGallery.slides.forEach((slide) => {
      slide.remove();
    });
    thumbGallery.slides.forEach((slide) => {
      slide.remove();
    });

    // Add the appropriate slides back to both galleries
    var slideContainer = mainGallery.slidesEl;
    variantSlides.forEach(slide => {
      slideContainer.append(slide);
    });
    
    let thumbContainer = thumbGallery.slidesEl;
    variantThumbs.forEach(thumb => {
      thumbContainer.append(thumb);
    });

    // Update both galleries
    mainGallery.update();
    thumbGallery.update();
    
    // Go to first slide
    //mainGallery.slideTo(0);
    //thumbGallery.slideTo(0);
}

function listenToVariantChange(activateVariantGallery) {
  //this.listenToAddToCartForms();
  //console.log(variantIdInput);
  if (variantIdInput.tagName === 'INPUT') {
    const variantIdObserver = new MutationObserver((mutationList) => {
      mutationList.forEach((mutationRecord) => {

        if (activateVariantGallery) {
          switchGallery(mutationRecord.target.value);
        }
        triggerDiscountDisplay();
      });
    });
    variantIdObserver.observe(variantIdInput, {
      attributes: true,
    });
  }
}

function displayDiscount() {
  //console.log('displayDiscount');
  const priceContainer = document.querySelector('.product__price');
  const currentPrice = priceContainer.querySelector('.price__regular .price-item');
  const compareAtPrice = priceContainer.querySelector('.price__sale .price-item');
  const priceDiscount = priceContainer.querySelector('.price__discount p');
  const floatingPrice = document.querySelector('.product__floating-form .price__regular');
  const floatingcompareAtPrice = document.querySelector('.product__floating-form .price__sale');
  console.log('floatingPrice', floatingPrice, floatingcompareAtPrice);
  if (currentPrice && compareAtPrice && priceDiscount) {
    const priceValue = parseFloat(currentPrice.innerText.trim().replace('$', ''));
    const compareAtPriceValue = parseFloat(compareAtPrice.innerText.trim().replace('$', ''));
    if (compareAtPriceValue > priceValue) {
      const discountPercent = Math.round(((compareAtPriceValue - priceValue) / compareAtPriceValue) * 100);
      //console.log('discountPercent', discountPercent);
      priceDiscount.textContent = `${discountPercent}% off`;
      priceDiscount.classList.add('discount-applied');
    }
    //console.log('priceValue', priceValue, compareAtPriceValue);
  }
  if (floatingPrice) {
    const regularPrice = document.querySelector('.price .price__regular');
    const salePrice = document.querySelector('.price .price__sale');
    const discountPercent = document.querySelector('.price .price__discount');
    floatingPrice.innerHTML = regularPrice.innerHTML;
    if (floatingcompareAtPrice && salePrice) {
      floatingcompareAtPrice.innerHTML = salePrice.innerHTML;
    }
    if (discountPercent) {
      const floatingDiscountPercent = document.querySelector('.product__floating-form .price .price__discount');
      if (floatingDiscountPercent) {
        floatingDiscountPercent.innerHTML = discountPercent.innerHTML;
      }
    }
  }
  updateDeliveryText();
}

function triggerDiscountDisplay() {
  let counter = 0;
  let looper = setInterval(function(){ 
      counter++;
      displayDiscount();
      if (counter >= 10) {
          clearInterval(looper);
      }

  }, 100);
}

OG.addOptinChangedCallback((e, f) => {
  console.log('og optin changed', e, f);
  triggerDiscountDisplay();
});



  document.addEventListener('DOMContentLoaded', function() {
    let galleryContainer = document.querySelector('.main-product-gallery--variant-gallery');
    if (galleryContainer) {
      let variantId = variantIdInput.value;
      switchGallery(variantId);
      listenToVariantChange(true);
    } else {
      listenToVariantChange(false);
    }
    triggerDiscountDisplay();
  });
